const NotFound = () => {
  return (
    <div className='d-flex justify-content-center'>
      <h1>Not found!</h1>
    </div>
  );
};

export default NotFound;
